import { create } from 'zustand';

export interface ILoading {
  isFetchLoading: boolean;
  title?: string;
  text?: string;
}

export interface ILoadingState extends ILoading {
  setLoadingState: (data: ILoading) => void;
}

const useLoadingStore = create<ILoadingState>((set) => ({
  isFetchLoading: false,
  title: '데이터를 불러오는 중 입니다.',
  text: '잠시만 기다려 주세요.',
  setLoadingState: (data) =>
    set((state) => ({
      isFetchLoading: data.isFetchLoading,
      title: data?.title ?? '데이터를 불러오는 중 입니다.',
      text: data?.text ?? '잠시만 기다려 주세요.',
    })),
}));

export default useLoadingStore;
